/* eslint-disable max-len */
import * as React from 'react';

const Upload = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2197 3.21967C12.5126 2.92678 12.9874 2.92678 13.2803 3.21967L18.2803 8.21967C18.5732 8.51256 18.5732 8.98744 18.2803 9.28033C17.9874 9.57322 17.5126 9.57322 17.2197 9.28033L13.5 5.56066V15.75C13.5 16.1642 13.1642 16.5 12.75 16.5C12.3358 16.5 12 16.1642 12 15.75V5.56066L8.28033 9.28033C7.98744 9.57322 7.51256 9.57322 7.21967 9.28033C6.92678 8.98744 6.92678 8.51256 7.21967 8.21967L12.2197 3.21967ZM3.75 15C4.16421 15 4.5 15.3358 4.5 15.75V19.75C4.5 20.0815 4.6317 20.3995 4.86612 20.6339C5.10054 20.8683 5.41848 21 5.75 21H19.75C20.0815 21 20.3995 20.8683 20.6339 20.6339C20.8683 20.3995 21 20.0815 21 19.75V15.75C21 15.3358 21.3358 15 21.75 15C22.1642 15 22.5 15.3358 22.5 15.75V19.75C22.5 20.4793 22.2103 21.1788 21.6945 21.6945C21.1788 22.2103 20.4793 22.5 19.75 22.5H5.75C5.02065 22.5 4.32118 22.2103 3.80546 21.6945C3.28973 21.1788 3 20.4793 3 19.75V15.75C3 15.3358 3.33579 15 3.75 15Z"
      fill="#D1D1D1"
    />
  </svg>
);
export default Upload;
